// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fullscreen overlay */
.disclaimer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;
}

/* Main popup container */
.disclaimer-content {
    background: #ffffff;
    width: 100%;
    max-width: 850px;
    border-radius: 12px;
    padding: 25px;
    box-sizing: border-box;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    font-family: Arial, sans-serif;
    color: #222;
    animation: fadeIn 0.3s ease-in-out;
}

/* Heading */
.disclaimer-content h4 {
    text-align: center;
    margin-bottom: 15px;
    font-size: 28px;
    color: #000;
}

/* Subtitle */
.disclaimer-content h5 {
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    color: #333;
}

/* Disclaimer text */
.disclaimer-points {
    margin-top: 20px;
}

.disclaimer-points p {
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 14px;
    text-align: justify;
    color: #444;
}

/* Button */
.disclaimer-content button {
    display: block;
    margin: 25px auto 0;
    padding: 12px 28px;
    background: #3a10f3;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
    transition: 0.3s ease;
}

.disclaimer-content button:hover {
    background: #f63333;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .disclaimer-content {
        padding: 18px;
        border-radius: 10px;
    }

    .disclaimer-content h4 {
        font-size: 22px;
    }

    .disclaimer-content h5 {
        font-size: 14px;
    }

    .disclaimer-points p {
        font-size: 14px;
        line-height: 1.6;
    }

    .disclaimer-content button {
        width: 100%;
        font-size: 15px;
    }
}

/* Small mobile devices */
@media (max-width: 480px) {
    .disclaimer-content {
        padding: 15px;
    }

    .disclaimer-content h4 {
        font-size: 20px;
    }

    .disclaimer-points p {
        font-size: 13px;
    }
}

/* Smooth popup animation */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/Disclaimer.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,8BAA8B;IAC9B,WAAW;IACX,kCAAkC;AACtC;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA,aAAa;AACb;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA,WAAW;AACX;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,yBAAyB;AACzB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Fullscreen overlay */\n.disclaimer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    padding: 15px;\n    box-sizing: border-box;\n    overflow-y: auto;\n}\n\n/* Main popup container */\n.disclaimer-content {\n    background: #ffffff;\n    width: 100%;\n    max-width: 850px;\n    border-radius: 12px;\n    padding: 25px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    font-family: Arial, sans-serif;\n    color: #222;\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Heading */\n.disclaimer-content h4 {\n    text-align: center;\n    margin-bottom: 15px;\n    font-size: 28px;\n    color: #000;\n}\n\n/* Subtitle */\n.disclaimer-content h5 {\n    font-size: 16px;\n    line-height: 1.6;\n    margin: 0;\n    color: #333;\n}\n\n/* Disclaimer text */\n.disclaimer-points {\n    margin-top: 20px;\n}\n\n.disclaimer-points p {\n    font-size: 15px;\n    line-height: 1.7;\n    margin-bottom: 14px;\n    text-align: justify;\n    color: #444;\n}\n\n/* Button */\n.disclaimer-content button {\n    display: block;\n    margin: 25px auto 0;\n    padding: 12px 28px;\n    background: #3a10f3;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: 0.3s ease;\n}\n\n.disclaimer-content button:hover {\n    background: #f63333;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n    .disclaimer-content {\n        padding: 18px;\n        border-radius: 10px;\n    }\n\n    .disclaimer-content h4 {\n        font-size: 22px;\n    }\n\n    .disclaimer-content h5 {\n        font-size: 14px;\n    }\n\n    .disclaimer-points p {\n        font-size: 14px;\n        line-height: 1.6;\n    }\n\n    .disclaimer-content button {\n        width: 100%;\n        font-size: 15px;\n    }\n}\n\n/* Small mobile devices */\n@media (max-width: 480px) {\n    .disclaimer-content {\n        padding: 15px;\n    }\n\n    .disclaimer-content h4 {\n        font-size: 20px;\n    }\n\n    .disclaimer-points p {\n        font-size: 13px;\n    }\n}\n\n/* Smooth popup animation */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(15px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
